<template>
  <!-- <div id="player-container" style="display:none;">
    <div ref="youtubePlayer"></div>
  </div> -->
  <div class="match-detail-sidebar">
    <div class="official-highlight" v-if="youtubeVideoUrl && !youtubeLoading">
      <div class="match-detail-sidebar-title">
        {{ $t("HIGHLIGHTS") }}
      </div>

      <!-- <div class="official-highlight-youtube-link">
            https:{{ fullHighlight.videoUrl }}
          </div> -->

      <div class="youtube-box">
        <div class="youtube-frame-box" v-if="youtubeEnable">
          <div class="cover-box" @click="playPlayer()"></div>
          <iframe
            :src="youtubeVideoUrl"
            class="youtube-frame"
            allow="fullscreen"
            ref="youtubeVideoFrame"
          />
        </div>
        <div v-else class="ratio-169-container">
          <DefaultHighLightUi :videoUrl="fullHighlight.videoUrl" />
        </div>
      </div>
      <!-- https://www.youtube.com/embed/mtLbr_K3WyM -->
      <!-- <iframe src="https://www.youtube.com/live/JZmQ4n6hrHc?si=Tv0FWXx5Gd4ZqDse" /> -->
    </div>

    <div
      class="youtube-box2"
      id="youtube-box2"
      :class="{
        in: displayHighlight && !firstTimeLoadYoutube,
      }"
      v-show="youtubeEnable && displayHighlight"
    >
      <div class="youtube-header">
        <SvgIcon icon="popup.close.icon.dark" @click="closePlayer()"></SvgIcon>
      </div>
      <iframe
        :src="youtubeVideoUrl"
        class="youtube-frame"
        allow="fullscreen"
        v-if="isNormalVideo && displayHighlight"
      />
      <div
        ref="youtubePlayer"
        class="youtube-frame"
        v-show="!isNormalVideo"
      ></div>
    </div>

    <div class="match-info mb-15rem">
      <div class="match-detail-sidebar-title">
        {{ $t("SHARE") }}
      </div>

      <SocialMediaSharing></SocialMediaSharing>
    </div>

    <div class="match-info">
      <div class="match-detail-sidebar-title">
        {{ $t("MATCH_INFO") }}
      </div>

      <div class="match-info-list">
        <div class="match-info-item" v-if="matchDetailInfo.matchDate">
          <IconMode>
            <template #default="{ index }">
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_1.png"
                v-if="['lightWeb', 'lightWebapp'].includes(index)"
              />
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_1_dark.png"
                v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
              />
            </template>
          </IconMode>
          <span>{{ matchDetailInfo.matchDate }}</span>
        </div>
        <div class="match-info-item" v-if="matchDetailInfo.referee">
          <IconMode>
            <template #default="{ index }">
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_2.png"
                v-if="['lightWeb', 'lightWebapp'].includes(index)"
              />
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_2_dark.png"
                v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
              />
            </template>
          </IconMode>
          <span>{{ matchDetailInfo.referee }}</span>
        </div>
        <div class="match-info-item" v-if="matchDetailInfo.stadium">
          <IconMode>
            <template #default="{ index }">
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_3.png"
                v-if="['lightWeb', 'lightWebapp'].includes(index)"
              />
              <img
                src="@static/images/icons/aspn_icon/match_info/match_icon_3_dark.png"
                v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
              />
            </template>
          </IconMode>
          <span>{{ matchDetailInfo.stadium }}</span>
        </div>
      </div>
    </div>

    <div class="match-detail-estimated-probability" v-if="isShowEstProb">
      <div class="match-detail-sidebar-title">
        {{ $t("ESTIMATED_PROBABILITY") }}
      </div>

      <div
        class="estimated-probability-list"
        v-if="Object.keys(matchDetailWinRate).length !== 0"
      >
        <div class="estimated-probability-item">
          <Icon
            :logoUrl="matchDetailWinRate.homeLogo"
            class="estimated-probability-img"
          ></Icon>
          <div class="estimated-probability-progress">
            <div
              class="rate-progress win-rate"
              :style="{
                width: `${matchDetailWinRate.winRate}%`,
                borderRadius:
                  matchDetailWinRate.winRate > 98 ? '8px' : '8px 0 0 8px',
              }"
            ></div>
            <div class="rate-text">{{ matchDetailWinRate.winRate }}%</div>
          </div>
        </div>
        <div class="estimated-probability-item">
          <IconMode>
            <template #default="{ index }">
              <img
                src="@static/images/icons/aspn_icon/estimated_probability/2.png"
                v-if="['lightWeb', 'lightWebapp'].includes(index)"
                class="estimated-probability-img"
              />
              <img
                src="@static/images/icons/aspn_icon/estimated_probability/2_dark.png"
                v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
                class="estimated-probability-img"
              />
            </template>
          </IconMode>
          <div class="estimated-probability-progress">
            <div
              class="rate-progress draw-rate"
              :style="{
                width: `${matchDetailWinRate.drawRate}%`,
                borderRadius:
                  matchDetailWinRate.drawRate > 98 ? '8px' : '8px 0 0 8px',
              }"
            ></div>
            <div class="rate-text">{{ matchDetailWinRate.drawRate }}%</div>
          </div>
        </div>
        <div class="estimated-probability-item">
          <Icon
            :logoUrl="matchDetailWinRate.awayLogo"
            class="estimated-probability-img"
          ></Icon>
          <div class="estimated-probability-progress">
            <div
              class="rate-progress lose-rate"
              :style="{
                width: `${matchDetailWinRate.loseRate}%`,
                borderRadius:
                  matchDetailWinRate.loseRate > 98 ? '8px' : '8px 0 0 8px',
              }"
            ></div>
            <div class="rate-text">{{ matchDetailWinRate.loseRate }}%</div>
          </div>
        </div>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import DefaultHighLightUi from "@/components/highlights/DefaultUi.vue";
import SocialMediaSharing from "@/components/socialMediaSharing/SocialMediaSharing.vue";
export default {
  components: {
    DefaultHighLightUi,
    SocialMediaSharing,
  },
  props: ["matchDetailInfo", "matchDetailWinRate", "showEstProb"],
  data() {
    return {
      firstTimeLoadYoutube: true,
      youtubeLoading: true,
      youtubeEnable: false,
      displayHighlight: false,
      matchId: "",
      fullHighlight: {},
      s3ImgUrl: config.s3ImgUrl,
      player: {},
      player2: "",
      youtubeVideoUrl: "",
      youtubeVideoId: "",
      isNormalVideo: false,
      isShowEstProb: this.showEstProb == undefined ? true : false,
    };
  },
  watch: {
    isMobileRealTime(newVal) {
      if (!newVal) {
        this.getFullHighlightListData();
        // this.checkYoutubeAvailable()
      }
    },
  },
  computed: {
    ...mapGetters(["isMobile", "isMobileRealTime"]),
  },
  created() {
    this.matchId = this.$route.params.matchId;
  },
  mounted() {
    if (!this.isMobile) {
      this.getFullHighlightListData();
    }
  },
  methods: {
    ...mapActions(["getFullHighlightList"]),
    async getFullHighlightListData() {
      const result = await this.getFullHighlightList({
        matchId: this.matchId,
      });
      if (result.errorCode === 0) {
        if (result.result[0]) {
          this.fullHighlight = result.result[0];
          this.videoUrl();
        }
      }
    },
    checkYoutubeAvailable() {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = (videoId) => {
        this.player = new YT.Player(this.$refs.youtubePlayer, {
          videoId: this.youtubeVideoId,
          width: 504,
          height: 281,
          events: {
            onReady: this.onVideoReady,
            onError: this.onVideoError,
          },
        });
        // if(this.firstTimeLoadYoutube) {
        //   this.firstTimeLoadYoutube = false;
        // }
      };
    },
    onVideoReady(event) {
      this.youtubeEnable = true;
      this.youtubeLoading = false;
      this.player2 = event.target;
      this.firstTimeLoadYoutube = false;
    },
    playPlayer() {
      if (!this.displayHighlight) {
        if (!this.isNormalVideo) {
          this.player2.playVideo();
        }
        this.displayHighlight = true;
      }
    },
    closePlayer() {
      let div = document.getElementById("youtube-box2");
      div.classList.add("out");
      if (!this.isNormalVideo) {
        this.player2.stopVideo();
      }
      setTimeout(() => {
        this.displayHighlight = false;
        div.classList.remove("out");
      }, 1000);
    },
    onVideoError(e) {
      // 2 = Invalid parameter	请求中包含非法参数，例如 videoId 格式错误。
      // 5 =	HTML5 player error
      // 100 = Video not found 无效或视频被删除/设为私密。
      // 101 = Embedding not allowed 禁止视频嵌入到其他网站。
      // 150 = Embedding not allowed
      if ([2, 5, 100, 101, 150].includes(e.data)) {
        this.youtubeEnable = false;
        this.youtubeLoading = false;
      }
    },
    // createPlayer() {
    //   this.player = new YT.Player(this.$refs.youtubeBox2Player, {
    //     height: '360',
    //     width: '640',
    //     videoId: 'VIDEO_ID', // 替换为你的 YouTube 视频 ID
    //     events: {
    //       'onReady': this.onPlayerReady
    //     }
    //   });
    // },
    videoUrl() {
      if (this.fullHighlight.videoUrl) {
        const prefix = "https://www.youtube.com/embed/";
        const youtubeRegex = /(?:youtube\.com|youtu\.be)/i;

        if (!youtubeRegex.test(this.fullHighlight.videoUrl)) {
          this.youtubeEnable = true;
          this.isNormalVideo = true;
          this.youtubeVideoUrl = this.fullHighlight.videoUrl;
          this.youtubeLoading = false;
          // return this.fullHighlight.videoUrl
        }

        try {
          const parsedUrl = new URL(this.fullHighlight.videoUrl);

          // 如果是 youtube.com 格式，取 v 参数
          if (parsedUrl.hostname.includes("youtube.com")) {
            let id = parsedUrl.searchParams.get("v");
            this.youtubeVideoUrl = prefix + id;
            this.youtubeVideoId = id;
            this.checkYoutubeAvailable();
            window.onYouTubeIframeAPIReady();
          }

          // 如果是 youtu.be 短链接格式，取 pathname（去掉开头的 /）
          if (parsedUrl.hostname.includes("youtu.be")) {
            let id = parsedUrl.pathname.slice(1);
            this.youtubeVideoUrl = prefix + id;
            this.youtubeVideoId = id;
            this.checkYoutubeAvailable();
            window.onYouTubeIframeAPIReady();
          }
        } catch (e) {
          return null;
        }
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.match-detail-sidebar {
  width: 300px;
  flex-shrink: 0;
}
.match-detail-sidebar-title {
  font-size: var(--typography-heading-size-extra-small);
  font-family: var(--weight-700);
  margin-bottom: 16px;
  color: var(--color-text-default-default);
}
.match-detail-content-box {
  gap: 24px;
}
.match-info {
  border-radius: var(--size-radius-400);
  background: var(--color-background-default-secondary);
  padding: 16px;
}
.match-detail-estimated-probability {
  margin-top: 24px;
  padding: 16px;
  border-radius: var(--size-radius-400);
  background: var(--color-background-default-secondary);
}
.match-info-item {
  display: flex;
  margin-bottom: 18px;
  align-items: center;
  color: var(--color-text-default-default);
}
.match-info-item:last-child {
  margin-bottom: 0;
}
.match-info-item img {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.estimated-probability-list {
}
.estimated-probability-item {
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  margin-bottom: 24px;
}
.estimated-probability-item:last-child {
  margin-bottom: 0px;
}
.estimated-probability-img {
  width: 27px;
}
.estimated-probability-progress {
  width: calc(100% - 37px);
  height: 16px;
  background-color: var(--color-bar-background);
  border-radius: var(--size-radius-200);
  position: absolute;
  top: calc(50% - 8px);
  border-radius: 8px;
  left: 37px;
}

.rate-progress {
  height: 16px;
  border-radius: 8px 0 0 8px;
  position: absolute;
}
.win-rate {
  background-color: var(--primary-400);
}
.draw-rate {
  background-color: var(--color-background-neutral-default);
}
.lose-rate {
  background-color: var(--secondary-400);
}
.rate-text {
  display: flex;
  justify-content: right;
  font-size: var(--typography-caption-size-small);
  font-family: var(--weight-700);
  line-height: 16px;
  margin-right: 8px;
  color: var(--color-text-default-default);
  position: relative;
  letter-spacing: 0.2px;
}

.official-highlight {
  border-radius: var(--size-radius-400);
  background: var(--color-background-default-secondary);
  padding: 16px;
  margin-bottom: 24px;
}
.official-highlight .match-detail-sidebar-title {
  margin-bottom: 16px;
}
.official-highlight-youtube-link {
  color: var(--color-text-default-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.youtube-frame {
  width: 100%;
  border-radius: 8px;
  border: 0;
}
.youtube-box {
  position: relative;
  width: 100%;
}
.youtube-box2 {
  width: 505px;
  height: 281px;
  position: fixed;
  bottom: 24px;
  right: 20.88px;
  border-radius: 8px;
  z-index: 999;
  animation: zoomIn 1s;
  padding: 0;
}
.youtube-box2 .youtube-frame {
  margin-top: 0;
  width: 100%;
  height: 100%;
}

.youtube-box2.in {
  animation: zoomIn 1s;
}
.youtube-box2.out {
  animation: zoomOut 1s;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0);
    transform-origin: right bottom;
  }
  to {
    opacity: 1;
    transform: scale(1);
    transform-origin: left top;
  }
}
@keyframes zoomOut {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: left top;
  }
  to {
    opacity: 0;
    transform: scale(0);
    transform-origin: right bottom;
  }
}
.youtube-frame-box {
  position: relative;
}
.cover-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  cursor: pointer;
}
.youtube-header {
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 50%;
  cursor: pointer;
}

@media (max-width: 768px) {
  /* for test */
  .match-detail-sidebar {
    display: none;
  }
}
</style>

<style>
.html5-video-player {
  border-radius: 8px;
}
.youtube-frame {
  border-radius: 8px !important;
}
</style>
